var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "c-textarea",
        class: {
          "c-textarea--with-floating-label": _vm.floatingLabel,
          "c-textarea--active-floating-label": _vm.value && _vm.floatingLabel,
          "c-textarea--invalid": _vm.invalid,
          "c-textarea--focused": _vm.focused,
        },
      },
      [
        _vm.label
          ? _c("div", { staticClass: "c-textarea__label" }, [
              _vm._v(" " + _vm._s(_vm.label) + " "),
            ])
          : _vm._e(),
        _vm.floatingLabel
          ? _c("div", { staticClass: "c-textarea__floating-label--hidden" }, [
              _vm._v(_vm._s(_vm.floatingLabel)),
            ])
          : _vm._e(),
        _c("div", { staticClass: "c-textarea__wrapper" }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.textValue,
                expression: "textValue",
              },
            ],
            ref: "field",
            staticClass: "c-textarea__field",
            attrs: {
              rows: "1",
              maxlength: _vm.maxLength,
              placeholder: _vm.placeholder,
            },
            domProps: { value: _vm.textValue },
            on: {
              focus: function ($event) {
                _vm.focused = true
              },
              focusout: function ($event) {
                _vm.focused = false
              },
              input: function ($event) {
                if ($event.target.composing) return
                _vm.textValue = $event.target.value
              },
            },
          }),
          _vm.floatingLabel
            ? _c("div", { staticClass: "c-textarea__floating-label" }, [
                _vm._v(" " + _vm._s(_vm.floatingLabel) + " "),
              ])
            : _vm._e(),
          _c("div", { staticClass: "c-textarea__actions" }, [
            _vm.clearable
              ? _c(
                  "div",
                  {
                    staticClass: "c-textarea__action c-textarea__clear",
                    class: { "c-textarea__clear--active": _vm.textValue },
                    on: { click: _vm.clear },
                  },
                  [
                    _c("svg-icon", {
                      attrs: { name: "times", size: "md", color: "secondary" },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
        _c("div", { staticClass: "c-textarea__border" }),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }